import { Component, Inject, OnInit } from '@angular/core';
import {
	MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
	MatLegacyDialog as MatDialog,
	MatLegacyDialogRef as MatDialogRef,
} from '@angular/material/legacy-dialog';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { BaseComponent } from '@shared/base/base.component';
import { ProjectDialog, ProjectDialogInputData } from '../project-dialog/project-dialog.component';
import { PROJECT_TYPES } from '@domain/constants/project-types';
import { KeyValue } from '@angular/common';

@Component({
	selector: 'app-project-type-dialog',
	templateUrl: './project-type-dialog.component.html',
	styleUrls: ['./project-type-dialog.component.scss'],
})
export class ProjectTypeDialogComponent extends BaseComponent implements OnInit {
	projectTypes: any = PROJECT_TYPES;
	projectTypeDetails: FormGroup = new FormGroup({
		type: new FormControl('', [Validators.required]),
	});

	async ngOnInit() {
		this.projectTypeDetails.patchValue({
			type: PROJECT_TYPES.PROCUREMENT.value,
		});
	}

	constructor(
		public dialog: MatDialog,
		public dialogRef: MatDialogRef<ProjectTypeDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: ProjectDialogInputData
	) {
		super();
	}

	createProject(): void {
		const data: ProjectDialogInputData = {
			...this.data,
			type: this.projectTypeDetails.get('type').value,
		};
		const projectDialogRef = this.dialog.open(ProjectDialog, {
			panelClass: 'cargo_chief_dialog_container',
			width: '950px',
			data,
			disableClose: true,
		});
		this.dialogRef.close(projectDialogRef);
	}

	closeDialog(data: any): void {
		this.dialogRef.close(data);
	}

	sortProjects(a: KeyValue<string, any>, b: KeyValue<string, any>): number {
		return a.value.sortOrder - b.value.sortOrder;
	}
}
